import { poolData } from '../../../../UserPool';
import { getApiUrl } from '../../../commons';
import { getProjectStore } from '../../../../store/projectStore';

/**
 * Fetch deployments
 * @returns {Promise<Array>} Array of deployment objects
 */
export async function fetchDeployments(fetchAll=false) {
    try {
        await poolData.refreshToken();
    } catch (e) { /* noop */ }

    const apiURL = getApiUrl(poolData.envURL);
    const url = `${apiURL}/deploy/deployments${fetchAll?"":"/project"}?limit=10000&offset=0`;

    const response = await fetch(url, {
        headers: {
            Authorization: `Bearer ${poolData.accessToken}`,
            'Content-Type': 'application/json',
            'x-project-id': getProjectStore().currentProjectId || '',
            'x-environment-id': getProjectStore().currentSEnv || '',
        },
    });

    if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
    }

    const data = await response.json();

    return data.deployments;
}


/**
 * reDeploy a deployment
 * @param {string} deploymentId - The deployment_id to reDeploy
 * @returns {Promise<Object>} The updated deployment object
 */

export async function reDeploy(deploymentData) {
  try {
    await poolData.refreshToken();
    const apiURL = getApiUrl(poolData.envURL);
    const url = `${apiURL}/deploy/deployments/${deploymentData.deployment_id}/redeploy`;

    const response = await fetch(url, {
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${poolData.accessToken}`,
        'Content-Type': 'application/json',
        'x-project-id': `${getProjectStore().currentProjectId}`,
        'x-environment-id': `${getProjectStore().currentSEnv}`,
      },
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error(`[deployService] reDeploy failed: HTTP ${response.status} - ${response.statusText}`);

      if (response.status === 400) {
        throw new Error('Invalid reDeploy request: ' + errorText);
      } else if (response.status === 409) {
        throw new Error('reDeploy failed: ' + deploymentData.deployment_id);
      } else {
        throw new Error(`Failed to reReploy: ${response.status} ${response.statusText}`);
      }
    }

    const contentType = response.headers.get('content-type');
    if (!contentType || !contentType.includes('application/json')) {
      console.warn('[deployService] reDeploy: Expected JSON but received:', contentType);
      return null;
    }

    const data = await response.json();
    return data;

  } catch (e) {
    console.error('[deployService] reDeploy error:', e.message);
    throw e; // Re-throw to allow caller to handle
  }
}


/**
 * Rollback a deployment
 * @param {string} deploymentId - The deployment_id to rollback
 * @returns {Promise<Object>} The updated deployment object
 */
export async function rollbackDeployment(deploymentId) {
    try {
        await poolData.refreshToken();
    } catch (e) { /* noop */ }

    const apiURL = getApiUrl(poolData.envURL);
    const url = `${apiURL}/deploy/deployments/${deploymentId}/rollback`;

    const response = await fetch(url, {
        method: 'PUT',
        headers: {
            Authorization: `Bearer ${poolData.accessToken}`,
            'Content-Type': 'application/json',
            'x-project-id': getProjectStore().currentProjectId || '',
            'x-environment-id': getProjectStore().currentSEnv || '',
        },
    });

    if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
    }

    return response.json();
}
